<template>
  <dl-alert-page :fetching="false" :error="error" :redirect="redirectRoute" mod-redirect-message="Terug naar de startpagina"/>
</template>

<script lang="ts" src="./page-not-found.ts">

</script>
